const initialState = {
}

const actionTypes = {
  userError: 'errors/userError',
  serverError: 'errors/serverError'
}

const userError = (error) => (dispatch) => {
  dispatch({ type: actionTypes.userError, error })
}
const serverError = (error) => (dispatch) => {
  dispatch({ type: actionTypes.serverError, error })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.userError: {
      break
    }
    case actionTypes.serverError: {
      break
    }
    default: break
  }
  return state
}

export {
  reducer,
  userError,
  serverError
}



// WEBPACK FOOTER //
// ./src/store/Errors.js